import React, {useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { CaDashboardTable } from '../../../features/correctiveActions/dashboardTableCorrectiveAction/CaDashobardTable';
import { CaMangerTl } from '../../../features/correctiveActions/managerTlViewSearch/CaMangerTlView';

interface CaDashboardScorecardProps {
    caData : any
}
export const CaDashboardScorecard = (props: CaDashboardScorecardProps) => {
    const [visible, setVisible] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState<any>();
    const hideDialog = () => {
        setVisible(false);
    };
 
    const handleSelectedEmployee = (arg: any) => {
        setSelectedEmployee(arg)
        setVisible(true);
    }

    return (
        <>

            <CaDashboardTable setSelectedEmployee={handleSelectedEmployee} fromPage='ScorecardDashboard' caMangerTlData={props.caData} />
            <Dialog
                header="Corrective Action Details"
                visible={visible}
                style={{ width: '80vw' }}
                onHide={hideDialog}
                modal
            >
                <CaMangerTl handleCloseDialog={hideDialog} type={'update'} getDetails via={'scorecardDashboard'} selectedEmployee={selectedEmployee} view={false} />
            </Dialog>
        </>
    )
}   